import axios from '../axios'

export default class Home {
  async QuranPrograms(params) {
    const response = await axios.get(`/all-eduprograms`, { params })

    return response.data
  }
  
  async QuranProgram(id,params) {
    const response = await axios.get(`/eduprograms-details/${id}`, { params })

    return response.data
  }
  
  async Statics(params){
    const response = await axios.get('/setting-data',{params});
    return response.data
  }

  async News(params) {
    const response = await axios.get(`/getnews`, { params })

    return response.data
  }

  async VideoGallery(params) {
    const response = await axios.get(`/get-video-gallery`, { params })

    return response.data
  }

}
